
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12147',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12147",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.465",
  "dashboard-client-types": "static-1.365",
  "data-fetching-client": "static-1.9644",
  "foundations-components": "static-1.7868",
  "foundations-components-legacy": "static-1.893",
  "foundations-theming": "static-1.4390",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7986",
  "hub-http-shared-msw-handlers": "static-1.9887",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11437",
  "I18n": "static-7.1615",
  "jasmine-runner": "static-1.6439",
  "marketplace-storefront-base": "static-1.12208",
  "quartz": "static-1-hqd-quartz-routing-v2.19",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "static-1.2831",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.73",
  "settings-ui-lib": "static-1.12493",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7077",
  "ui-addon-i18n": "static-1.11122",
  "ui-addon-react-router-dom": "static-1.9516",
  "unified-auth": "static-1.456",
  "unified-auth-core-lib": "static-1.737",
  "usage-tracker": "static-1.7317",
  "usage-tracker-core": "static-1.7167",
  "customer-data-property-utils": "static-1.8057",
  "hub-http": "static-1.6194",
  "integrations-lib": "static-1.16020",
  "marketplace-ui-common": "static-1.19608",
  "property-management-iframe": "static-1.13042",
  "quartz-config": "static-1-hqd-quartz-routing-v2.19",
  "quartz-core": "static-1-hqd-quartz-routing-v2.19",
  "quartz-routing": "static-1-hqd-quartz-routing-v2.19",
  "quick-fetch": "static-1.3892",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4623",
  "ts-schema": "static-1.4054",
  "ui-universal-auth": "static-1.8942",
  "UIComponents": "static-3.8384",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3379",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1-hqd-quartz-routing-v2.19",
  "quartz-webpack": "static-1-hqd-quartz-routing-v2.19",
  "bend-plugin-quartz-routing": "static-1-hqd-quartz-routing-v2.18",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4137",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4834",
  "foundations-theming-specialty": "static-1.2106",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9400",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5320",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1771",
  "ui-fonts": "static-1.699",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-theming": "static-1.2873",
  "foundations-theming-base": "static-1.3375",
  "stylex": "static-1.32",
  "HeadJS": "static-2.746",
  "hs-test-utils-bend-plugin": "static-1.3097",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4298",
  "ai-components-ui-library": "static-1.8859",
  "ai-rendering-library": "static-1.10022",
  "chirp-fetch": "static-1.1859",
  "connections-embed-lib": "static-1.936",
  "copilot-toolkit": "static-1.11054",
  "feedback-loader": "static-1.29239",
  "laboratory-lib": "static-3.7131",
  "marketplace-embed": "static-1.21990",
  "marketplace-ui-details": "static-1.9504",
  "marketplace-ui-reviews": "static-1.19564",
  "marketplace-ui-tracking": "static-1.13779",
  "sanitize-text": "static-1.8114",
  "ui-addon-video-player": "static-1.8672",
  "usage-tracker-multi": "static-1.5731",
  "usage-tracker-session-replay": "static-1.5003",
  "wootric-nps": "static-1.6954",
  "quartz-head": "static-1-hqd-quartz-routing-v2.19",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4621",
  "immer": "static-1.33",
  "immerable": "static-1.4126",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2489",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.73",
  "cssUtils": "static-1.783",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11745",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10182",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10342",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7307",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18141",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4488",
  "foundations-components-test-utils": "static-1.5351",
  "quartz-i18n": "static-1-hqd-quartz-routing-v2.19",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.143",
  "microsoft-drive-integration-lib": "static-1.260",
  "fsm": "static-1.3702",
  "customer-data-objects": "static-1.7634",
  "property-translator": "static-1.5373",
  "hs-locale-management": "static-1.61",
  "frontend-preferences-client": "static-1.7901",
  "hs-promise-utils": "static-1.5566",
  "hubspot-apollo-client": "static-1.4849",
  "integrations-error-boundary-lib": "static-1.13435",
  "integrations-tracking-lib": "static-1.5571",
  "native-integrations-shared-strings": "static-1.7754",
  "reselect": "static-2.16",
  "sanitize": "static-1.4447",
  "superstore": "static-1.4736",
  "ui-shepherd-react": "static-3.10126",
  "ai-settings-ui-library": "static-1.7836",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4628",
  "immutable-less": "static-1.4624",
  "marketplace-ui-client-types": "static-1.17015",
  "nav-meta": "static-1.29573",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10217",
  "ui-addon-upgrades": "static-9.17941",
  "inbound-db-properties-service-client": "static-1.3819",
  "property-management-common": "static-1.5330",
  "ui-addon-iframeable": "static-1.9029",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.520",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1-hqd-quartz-routing-v2.19",
  "quartz-test": "static-1-hqd-quartz-routing-v2.19",
  "quartz-tracking": "static-1-hqd-quartz-routing-v2.19",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.33",
  "bender-build-tools": "static-1.3160",
  "inbound-db-meta-service-client": "static-1.3566",
  "persist-promise": "static-1.3670",
  "reference-resolvers": "static-1.8141",
  "transmute": "static-2.85",
  "hubspotter-http-shared-msw-handlers": "static-1.9885",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21142",
  "ContentUtils": "static-1.68268",
  "customer-data-objects-ui-components": "static-1.12997",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2470",
  "customer-data-filters-ui": "static-1.39646",
  "customer-data-reference-ui-components": "static-1.13131",
  "embedded-academy-lib": "static-1.14244",
  "ExportDialog": "static-6.10365",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41216",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.73",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.73",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.73",
  "ui-addon-teams": "static-1.21504",
  "magpie-lib": "static-1.5537",
  "navigation-components": "static-1.17936",
  "magpie-types": "static-1.4997",
  "simple-logging-lib": "static-1.3021",
  "ai-studio-lib": "static-1.11518",
  "app-governance-lib": "static-1.1446",
  "developer-experience-shared-components": "static-1.10482",
  "ui-addon-integrations-directory-panel": "static-2.7968",
  "ui-product-approvals": "static-1.28048",
  "ui-tool-access": "static-1.10122",
  "usage-based-billing-components-lib": "static-1.8723",
  "usage-tracker-anonymous": "static-1.5734",
  "usage-tracker-public": "static-1.7128",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3900",
  "hubspot-apollo-cache": "static-1.308",
  "universal-page-editor-lib": "static-1.2985",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2688",
  "merchandise-lib": "static-1.263",
  "atom": "static-1.5043",
  "purchase-motions-components": "static-1.5827",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1513",
  "crm-component-utils": "static-1.39000",
  "crm-properties-common-lib": "static-1.5851",
  "customer-data-properties": "static-1.51434",
  "framework-data-schema-resolvers": "static-1.6853",
  "property-value-citations": "static-1.2048",
  "reference-resolvers-lite": "static-1.8067",
  "navigation-messaging": "static-1.7263",
  "growth-payments-core": "static-1.25283",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13589",
  "conversations-skeleton-state": "static-1.7220",
  "crm-message-bus": "static-1.42907",
  "reporting-plugins": "static-1.10270",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.73",
  "cms-field-types": "static-1.4784",
  "content-icons-ui": "static-1.2217",
  "customer-data-ui-utilities": "static-1.9798",
  "customer-data-filters-ui-msw-helpers": "static-1.22081",
  "FormUrlGenerator": "static-2.4690",
  "framework-builder-read-service-client": "static-1.3985",
  "framework-data-schema-quick-fetch": "static-1.6758",
  "multi-account-reference-resolvers": "static-1.950",
  "onboarding-tours": "static-1.16540",
  "academy-common-lib": "static-1.13704",
  "content-assistance-lib": "static-1.7704",
  "dashboard-lib": "static-1.81393",
  "file-manager-components": "static-1.23533",
  "getting-started-shared-tasks": "static-1.18416",
  "hubspot-prosemirror": "static-1.18156",
  "hubspot-prosemirror-plugins": "static-1.18148",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19776",
  "share-with-third-party-component-lib": "static-1.8673",
  "ui-addon-draggable": "static-3.4740",
  "ui-asset-management-lib": "static-1.10982",
  "ui-business-units-lib": "static-1.9021",
  "user-context": "static-1.5074",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.694",
  "nest": "static-1.196",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10597",
  "framework-listing-lib": "static-2.28602",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30646",
  "apps-service-types": "static-1.3849",
  "oauth-service-types": "static-1.4222",
  "onboarding-scopes": "static-1.6434",
  "onboarding-tours-client": "static-1.4754",
  "platform-infra-nav-components": "static-1.7649",
  "subscription-experience-data-types": "static-1.14887",
  "crm-record-cards-service-types": "static-1.3584",
  "location-customization-utils-lib": "static-1.9158",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5830",
  "signup-constants": "static-1.18787",
  "signup-ui-url-generator": "static-2.8012",
  "trials-service-types": "static-1.3875",
  "card-properties-lib": "static-1.44083",
  "commerce-subscription-lib": "static-1.37015",
  "crm-actions": "static-1.6293",
  "crm-cards-sdk": "static-1.43491",
  "customer-data-properties-shared-msw-handlers": "static-1.9214",
  "customer-data-tracking": "static-1.6857",
  "hs-resources": "static-1.124",
  "pulse": "static-1.537",
  "calling-global-api": "static-1.64410",
  "calling-internal-common": "static-1.31275",
  "calling-lifecycle-internal": "static-1.65792",
  "calling-lifecycle-messages": "static-1.58086",
  "commerce-products-lib": "static-1.9439",
  "conditional-properties-service-client": "static-1.3773",
  "crm-links": "static-1.6257",
  "external-options-client-types": "static-1.4134",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4199",
  "meetings-icalendar-utils-lib": "static-1.604",
  "multi-currency-client-types": "static-1.3667",
  "object-builder-ui-client": "static-1.48631",
  "pipeline-validation-client-types": "static-1.3941",
  "smart-property-lib": "static-1.6765",
  "tiered-pricing": "static-1.1135",
  "ui-addon-form-validation": "static-1.10962",
  "crm-pipelines-api-client-types": "static-1.4118",
  "ui-addon-opt": "static-4.8342",
  "campaign-roi-lib": "static-1.9001",
  "react-dnd-compat": "static-1.4592",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5380",
  "growth-onboarding-confetti": "static-1.3039",
  "growth-onboarding-next-action-utils": "static-1.1831",
  "onboarding-tours-utils": "static-1.606",
  "ui-shepherd-tracker": "static-1.7507",
  "academy-service-client": "static-1.3654",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39032",
  "FileManagerLib": "static-1.39173",
  "video-embed": "static-1.35662",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28462",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11170",
  "video-data-lib": "static-1.34828",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23448",
  "ui-addon-emoji-picker": "static-1.9859",
  "EmailSignatureEditor": "static-1.24302",
  "viral-links-lib": "static-1.7028",
  "data-token-picker": "static-1.16352",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.197",
  "timezone-utils": "static-2.5216",
  "getting-started-shared-tasks-store": "static-1.17534",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7296",
  "customer-data-views-management": "static-1.25388",
  "framework-data-table": "static-2.11843",
  "marketing-platform-lib": "static-1.6824",
  "nudge-client-utils": "static-1.2500",
  "nudge-custom-ui-functions": "static-1.979",
  "app-users-service-client": "static-1.5567",
  "app-users-service-types": "static-1.4975",
  "mini-checkout-client": "static-1.26719",
  "onboarding-utils": "static-1.5325",
  "permissions-shared-i18n-strings-fe": "static-1.2044",
  "ui-coaching-tips-shared-config": "static-1.28447",
  "edison-service-client-types": "static-1.359",
  "crm_data": "static-4.91863",
  "customer-data-sidebar": "static-2.45923",
  "enrichment-properties-lib": "static-1.15883",
  "commerce-billing-lib": "static-1.18976",
  "commerce-shared-components-lib": "static-1.18441",
  "commerce-tools-ui-lib": "static-1.10287",
  "crm-fe-perf": "static-1.22875",
  "bend-plugin-pulse": "static-1.40",
  "directed-graph": "static-1.907",
  "event-emitter": "static-1.920",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31281",
  "shared-worker-versioning": "static-1.11010",
  "calling-usage-tracker": "static-1.6515",
  "voice-sms-access-library": "static-1.854",
  "commerce-permissions": "static-1.739",
  "products-iframe-lib": "static-1.7845",
  "products-ui-components-shared-msw-handlers": "static-1.10269",
  "data-agent-kit": "static-1.145",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9970",
  "policy-lib": "static-1.6748",
  "react-tinymce": "static-1.55149",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10033",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54275",
  "tinymce-plugins": "static-1.57389",
  "tinymce-themes": "static-1.56245",
  "breeze-engine-lib": "static-1.510",
  "onboarding-data-sync-lib": "static-1.1909",
  "growth-onboarding-next-action-components": "static-1.1859",
  "user-context-client": "static-1.4584",
  "audio-components": "static-1.5869",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36684",
  "urlinator": "static-1.4505",
  "video-components": "static-1.13173",
  "outpost": "static-1.4157",
  "growth-onboarding-feedback-components": "static-1.6554",
  "content-media-composition-data-lib": "static-1.12155",
  "content-media-compositions": "static-2.16162",
  "media-bridge-lib": "static-1.18872",
  "commerce-tours-lib": "static-1.6034",
  "growth-onboarding-reliability": "static-1.5055",
  "sales-checkout-service-client": "static-1.3611",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21618",
  "sales-email-signature-service-client": "static-1.3815",
  "ts-utils-lib": "static-1.145",
  "crm-export-dialog": "static-1.6270",
  "crm-index-associations-lib": "static-1.6412",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1878",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2257",
  "nudge-renderer-utils": "static-1.2576",
  "whisper-core-api": "static-1.6531",
  "InboxConnectUtils": "static-4.14726",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5429",
  "settings-content-modals": "static-1.45988",
  "crm_universal": "static-1.21951",
  "customer-data-email": "static-1.17978",
  "card-payment-highlight-lib": "static-1.37076",
  "card-subscription-highlight-lib": "static-1.39438",
  "commerce-contract-lib": "static-1.11927",
  "invoices-highlight-card-lib": "static-1.54621",
  "orders-highlight-card-lib": "static-1.21384",
  "products-highlight-card-lib": "static-1.17723",
  "quotes-highlight-card-lib": "static-1.71898",
  "crm-source-interpretation-lib": "static-1.5311",
  "utility-belt": "static-1.2509",
  "payments-enrollment-embed-lib": "static-1.22669",
  "stripe-embedded-components": "static-1.7448",
  "customer-data-rte": "static-1.32910",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5662",
  "payments-post-enroll-local-storage-lib": "static-1.5081",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37988",
  "calling-orchestration-schema": "static-1.35631",
  "sales-views-client-types": "static-1.4236",
  "hub-http-contrib": "static-1.3011",
  "interframe": "static-3.4732",
  "tinymce-data": "static-1.40360",
  "ui-addon-sales-email": "static-1.5182",
  "layout-dnd-components": "static-1.12384",
  "layout-dnd-utils": "static-1.11359",
  "ui-brand-identity-lib": "static-1.15134",
  "NamespacedHubStyle": "static-2.9037",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22006",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1882",
  "checkout-sdk": "static-3.23562",
  "checkout-service-types": "static-1.3802",
  "company-details-components": "static-1.6169",
  "payment-method-components": "static-1.6885",
  "pricing-pages-ui-components": "static-1.13788",
  "quote-checkout-service-types": "static-1.3447",
  "upgrade-catalog-service-types": "static-1.3496",
  "access-control-lib": "static-1.10408",
  "EmailComponents": "static-1.54689",
  "EmailData": "static-1.53366",
  "redux-less": "static-2.9454",
  "sequences-lib": "static-1.7986",
  "ui-gdpr-components": "static-1.10319",
  "products-ui-components": "static-1.39958",
  "accounting-integrations-ui-components": "static-1.7014",
  "invoices-ui-lib": "static-1.54637",
  "commerce-products-api": "static-1.2240",
  "invoices-iframe-lib": "static-1.56695",
  "quotes-modal-lib": "static-1.102576",
  "quotes-ui-lib": "static-1.80619",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28178",
  "ContentData": "static-1.68343",
  "layout-data-lib": "static-1.9684",
  "hub-http-rxjs": "static-1.794",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3907",
  "billing-payments-client-types": "static-1.3962",
  "react-performance-metrics-lib": "static-1.531",
  "account-and-billing-fintech-outages": "static-3.18541",
  "pricing-pages-api": "static-1.13653",
  "ContentComponents": "static-2.71224",
  "marketing-contacts-lib": "static-1.9891",
  "marketing-email-service-types": "static-1.1900",
  "messaging-editing-lib": "static-1.46176",
  "messaging-usage-based-billing-components-lib": "static-1.1038",
  "automation-ui-source-apps": "static-1.18784",
  "automation-ui-types": "static-1.19702",
  "messaging-types-lib": "static-1.45914",
  "onboarding-settings-client": "static-1.4475",
  "sequences-client-types-lib": "static-1.7843",
  "commerce-tax-lib": "static-1.496",
  "price-books-api": "static-1.546",
  "price-books-components": "static-1.604",
  "property-description-translator": "static-1.3818",
  "ramp-editor": "static-1.69",
  "commerce-analytics-service-client": "static-1.3599",
  "totals-ui-components": "static-1.23507",
  "SalesContentIndexUI": "static-3.9196",
  "advanced-menus-core": "static-1.15083",
  "advanced-menus-lib": "static-1.12029",
  "ui-memberships-settings-lib": "static-1.33960",
  "segments-query-core": "static-1.1390",
  "demographics-service-types": "static-1.1624",
  "eligibility-engine-service-types": "static-1.3156",
  "automation-ui-ubb": "static-1.5618",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7311",
  "data-token-views": "static-1.16333",
  "forms-utils-lib": "static-1.12519",
  "payments-embed-points-lib": "static-1.12964",
  "simple-menus-core": "static-1.15082",
  "simple-menus-lib": "static-1.16599",
  "ui-addon-draggable-compat": "static-2.4227",
  "videoconference-integration-components": "static-1.6774",
  "marketing-contacts-client": "static-1.7491",
  "automation-applications-service-types": "static-1.3475",
  "automation-platform-service-types": "static-1.2576",
  "ContentEditorUI": "static-2.77026",
  "short-messages-app-service-client": "static-1.3949",
  "web-interactives-components": "static-1.13706",
  "web-interactives-data": "static-1.13707",
  "messaging-shared-utils-lib": "static-1.488",
  "messaging-user-info-utils-lib": "static-1.658",
  "email-portal-health-service-types": "static-1.948",
  "line-items-api": "static-1.641",
  "commerce-totals-service-types": "static-1.3794",
  "FireAlarmUi": "static-1.4488",
  "sales-templates-service-types-lib": "static-1.4144",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21638",
  "automation-ui-usage-tracking": "static-1.21101",
  "data-studio-ubb": "static-1.2633",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26949",
  "collaboration-sidebar": "static-1.57705",
  "content-management-data-lib": "static-1.5346",
  "copilot-plugins": "static-1.11027",
  "cta-picker": "static-1.36316",
  "customer-agent-discovery-components-lib": "static-1.3000",
  "editor-components": "static-1.13188",
  "editor-iframe-lib": "static-1.8359",
  "error-messaging-js": "static-1.5163",
  "FormsCommonComponents": "static-1.85753",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10617",
  "SharedLegalStrings": "static-1.1718",
  "smart-content-core": "static-1.42350",
  "smart-content-lib": "static-1.43003",
  "social-composer-lib": "static-1.58971",
  "structured-content-lib": "static-1.25106",
  "theme-previewer-lib": "static-1.53164",
  "tinymce-copilot": "static-1.16343",
  "xray-recommendation-lib": "static-1.7857",
  "automation-ui-routing": "static-1.21059",
  "sql-reporting-client-types": "static-1.5611",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42125",
  "campaigns-utils-lib": "static-1.3146",
  "reporting-enablement": "static-1.22807",
  "chatspot-widget-iframe": "static-1.21133",
  "collaboration-sidebar-common": "static-1.2502",
  "forms-ai-lib": "static-1.4271",
  "codemirror-dlb": "static-1.58585",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6401",
  "report-customization-components": "static-1.13073",
  "data-quality-ui-library": "static-1.12900",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.259",
  "reporting-insights-lib": "static-1.1646"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12147",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.465",
  "dashboard-client-types": "/dashboard-client-types/static-1.365",
  "data-fetching-client": "/data-fetching-client/static-1.9644",
  "foundations-components": "/foundations-components/static-1.7868",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.893",
  "foundations-theming": "/foundations-theming/static-1.4390",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7986",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9887",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11437",
  "I18n": "/I18n/static-7.1615",
  "jasmine-runner": "/jasmine-runner/static-1.6439",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12208",
  "quartz": "/quartz/static-1-hqd-quartz-routing-v2.19",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2831",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.73",
  "settings-ui-lib": "/settings-ui-lib/static-1.12493",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7077",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11122",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9516",
  "unified-auth": "/unified-auth/static-1.456",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.737",
  "usage-tracker": "/usage-tracker/static-1.7317",
  "usage-tracker-core": "/usage-tracker-core/static-1.7167",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8057",
  "hub-http": "/hub-http/static-1.6194",
  "integrations-lib": "/integrations-lib/static-1.16020",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19608",
  "property-management-iframe": "/property-management-iframe/static-1.13042",
  "quartz-config": "/quartz-config/static-1-hqd-quartz-routing-v2.19",
  "quartz-core": "/quartz-core/static-1-hqd-quartz-routing-v2.19",
  "quartz-routing": "/quartz-routing/static-1-hqd-quartz-routing-v2.19",
  "quick-fetch": "/quick-fetch/static-1.3892",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4623",
  "ts-schema": "/ts-schema/static-1.4054",
  "ui-universal-auth": "/ui-universal-auth/static-1.8942",
  "UIComponents": "/UIComponents/static-3.8384",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3379",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1-hqd-quartz-routing-v2.19",
  "quartz-webpack": "/quartz-webpack/static-1-hqd-quartz-routing-v2.19",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1-hqd-quartz-routing-v2.18",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4137",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4834",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2106",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9400",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5320",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1771",
  "ui-fonts": "/ui-fonts/static-1.699",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2873",
  "foundations-theming-base": "/foundations-theming-base/static-1.3375",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.746",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3097",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4298",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8859",
  "ai-rendering-library": "/ai-rendering-library/static-1.10022",
  "chirp-fetch": "/chirp-fetch/static-1.1859",
  "connections-embed-lib": "/connections-embed-lib/static-1.936",
  "copilot-toolkit": "/copilot-toolkit/static-1.11054",
  "feedback-loader": "/feedback-loader/static-1.29239",
  "laboratory-lib": "/laboratory-lib/static-3.7131",
  "marketplace-embed": "/marketplace-embed/static-1.21990",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9504",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19564",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13779",
  "sanitize-text": "/sanitize-text/static-1.8114",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8672",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5731",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5003",
  "wootric-nps": "/wootric-nps/static-1.6954",
  "quartz-head": "/quartz-head/static-1-hqd-quartz-routing-v2.19",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4621",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4126",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2489",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.73",
  "cssUtils": "/cssUtils/static-1.783",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11745",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10182",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10342",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7307",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18141",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4488",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5351",
  "quartz-i18n": "/quartz-i18n/static-1-hqd-quartz-routing-v2.19",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.143",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.260",
  "fsm": "/fsm/static-1.3702",
  "customer-data-objects": "/customer-data-objects/static-1.7634",
  "property-translator": "/property-translator/static-1.5373",
  "hs-locale-management": "/hs-locale-management/static-1.61",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7901",
  "hs-promise-utils": "/hs-promise-utils/static-1.5566",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4849",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13435",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5571",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7754",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4447",
  "superstore": "/superstore/static-1.4736",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10126",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7836",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4628",
  "immutable-less": "/immutable-less/static-1.4624",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17015",
  "nav-meta": "/nav-meta/static-1.29573",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10217",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17941",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3819",
  "property-management-common": "/property-management-common/static-1.5330",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9029",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.520",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1-hqd-quartz-routing-v2.19",
  "quartz-test": "/quartz-test/static-1-hqd-quartz-routing-v2.19",
  "quartz-tracking": "/quartz-tracking/static-1-hqd-quartz-routing-v2.19",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.33",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3566",
  "persist-promise": "/persist-promise/static-1.3670",
  "reference-resolvers": "/reference-resolvers/static-1.8141",
  "transmute": "/transmute/static-2.85",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9885",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21142",
  "ContentUtils": "/ContentUtils/static-1.68268",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12997",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2470",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39646",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13131",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14244",
  "ExportDialog": "/ExportDialog/static-6.10365",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41216",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.73",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.73",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.73",
  "ui-addon-teams": "/ui-addon-teams/static-1.21504",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "navigation-components": "/navigation-components/static-1.17936",
  "magpie-types": "/magpie-types/static-1.4997",
  "simple-logging-lib": "/simple-logging-lib/static-1.3021",
  "ai-studio-lib": "/ai-studio-lib/static-1.11518",
  "app-governance-lib": "/app-governance-lib/static-1.1446",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10482",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7968",
  "ui-product-approvals": "/ui-product-approvals/static-1.28048",
  "ui-tool-access": "/ui-tool-access/static-1.10122",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8723",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5734",
  "usage-tracker-public": "/usage-tracker-public/static-1.7128",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3900",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.308",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2985",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2688",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "atom": "/atom/static-1.5043",
  "purchase-motions-components": "/purchase-motions-components/static-1.5827",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1513",
  "crm-component-utils": "/crm-component-utils/static-1.39000",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5851",
  "customer-data-properties": "/customer-data-properties/static-1.51434",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6853",
  "property-value-citations": "/property-value-citations/static-1.2048",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8067",
  "navigation-messaging": "/navigation-messaging/static-1.7263",
  "growth-payments-core": "/growth-payments-core/static-1.25283",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13589",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7220",
  "crm-message-bus": "/crm-message-bus/static-1.42907",
  "reporting-plugins": "/reporting-plugins/static-1.10270",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.73",
  "cms-field-types": "/cms-field-types/static-1.4784",
  "content-icons-ui": "/content-icons-ui/static-1.2217",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9798",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22081",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4690",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3985",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6758",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.950",
  "onboarding-tours": "/onboarding-tours/static-1.16540",
  "academy-common-lib": "/academy-common-lib/static-1.13704",
  "content-assistance-lib": "/content-assistance-lib/static-1.7704",
  "dashboard-lib": "/dashboard-lib/static-1.81393",
  "file-manager-components": "/file-manager-components/static-1.23533",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18416",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18156",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18148",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19776",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8673",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4740",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10982",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9021",
  "user-context": "/user-context/static-1.5074",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.694",
  "nest": "/nest/static-1.196",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10597",
  "framework-listing-lib": "/framework-listing-lib/static-2.28602",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30646",
  "apps-service-types": "/apps-service-types/static-1.3849",
  "oauth-service-types": "/oauth-service-types/static-1.4222",
  "onboarding-scopes": "/onboarding-scopes/static-1.6434",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4754",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7649",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14887",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3584",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9158",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5830",
  "signup-constants": "/signup-constants/static-1.18787",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8012",
  "trials-service-types": "/trials-service-types/static-1.3875",
  "card-properties-lib": "/card-properties-lib/static-1.44083",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37015",
  "crm-actions": "/crm-actions/static-1.6293",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43491",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9214",
  "customer-data-tracking": "/customer-data-tracking/static-1.6857",
  "hs-resources": "/hs-resources/static-1.124",
  "pulse": "/pulse/static-1.537",
  "calling-global-api": "/calling-global-api/static-1.64410",
  "calling-internal-common": "/calling-internal-common/static-1.31275",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65792",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58086",
  "commerce-products-lib": "/commerce-products-lib/static-1.9439",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3773",
  "crm-links": "/crm-links/static-1.6257",
  "external-options-client-types": "/external-options-client-types/static-1.4134",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4199",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.604",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3667",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48631",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3941",
  "smart-property-lib": "/smart-property-lib/static-1.6765",
  "tiered-pricing": "/tiered-pricing/static-1.1135",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10962",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4118",
  "ui-addon-opt": "/ui-addon-opt/static-4.8342",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9001",
  "react-dnd-compat": "/react-dnd-compat/static-1.4592",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5380",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3039",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1831",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.606",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7507",
  "academy-service-client": "/academy-service-client/static-1.3654",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39032",
  "FileManagerLib": "/FileManagerLib/static-1.39173",
  "video-embed": "/video-embed/static-1.35662",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28462",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11170",
  "video-data-lib": "/video-data-lib/static-1.34828",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23448",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9859",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24302",
  "viral-links-lib": "/viral-links-lib/static-1.7028",
  "data-token-picker": "/data-token-picker/static-1.16352",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.197",
  "timezone-utils": "/timezone-utils/static-2.5216",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17534",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7296",
  "customer-data-views-management": "/customer-data-views-management/static-1.25388",
  "framework-data-table": "/framework-data-table/static-2.11843",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6824",
  "nudge-client-utils": "/nudge-client-utils/static-1.2500",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.979",
  "app-users-service-client": "/app-users-service-client/static-1.5567",
  "app-users-service-types": "/app-users-service-types/static-1.4975",
  "mini-checkout-client": "/mini-checkout-client/static-1.26719",
  "onboarding-utils": "/onboarding-utils/static-1.5325",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2044",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28447",
  "edison-service-client-types": "/edison-service-client-types/static-1.359",
  "crm_data": "/crm_data/static-4.91863",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45923",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15883",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18976",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18441",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10287",
  "crm-fe-perf": "/crm-fe-perf/static-1.22875",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.40",
  "directed-graph": "/directed-graph/static-1.907",
  "event-emitter": "/event-emitter/static-1.920",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31281",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11010",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6515",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.854",
  "commerce-permissions": "/commerce-permissions/static-1.739",
  "products-iframe-lib": "/products-iframe-lib/static-1.7845",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10269",
  "data-agent-kit": "/data-agent-kit/static-1.145",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9970",
  "policy-lib": "/policy-lib/static-1.6748",
  "react-tinymce": "/react-tinymce/static-1.55149",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10033",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54275",
  "tinymce-plugins": "/tinymce-plugins/static-1.57389",
  "tinymce-themes": "/tinymce-themes/static-1.56245",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.510",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1909",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1859",
  "user-context-client": "/user-context-client/static-1.4584",
  "audio-components": "/audio-components/static-1.5869",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36684",
  "urlinator": "/urlinator/static-1.4505",
  "video-components": "/video-components/static-1.13173",
  "outpost": "/outpost/static-1.4157",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6554",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12155",
  "content-media-compositions": "/content-media-compositions/static-2.16162",
  "media-bridge-lib": "/media-bridge-lib/static-1.18872",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6034",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5055",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3611",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21618",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3815",
  "ts-utils-lib": "/ts-utils-lib/static-1.145",
  "crm-export-dialog": "/crm-export-dialog/static-1.6270",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6412",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1878",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2257",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2576",
  "whisper-core-api": "/whisper-core-api/static-1.6531",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14726",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5429",
  "settings-content-modals": "/settings-content-modals/static-1.45988",
  "crm_universal": "/crm_universal/static-1.21951",
  "customer-data-email": "/customer-data-email/static-1.17978",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37076",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39438",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11927",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54621",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21384",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17723",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71898",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5311",
  "utility-belt": "/utility-belt/static-1.2509",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22669",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7448",
  "customer-data-rte": "/customer-data-rte/static-1.32910",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5662",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5081",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37988",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35631",
  "sales-views-client-types": "/sales-views-client-types/static-1.4236",
  "hub-http-contrib": "/hub-http-contrib/static-1.3011",
  "interframe": "/interframe/static-3.4732",
  "tinymce-data": "/tinymce-data/static-1.40360",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5182",
  "layout-dnd-components": "/layout-dnd-components/static-1.12384",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11359",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15134",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9037",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1882",
  "checkout-sdk": "/checkout-sdk/static-3.23562",
  "checkout-service-types": "/checkout-service-types/static-1.3802",
  "company-details-components": "/company-details-components/static-1.6169",
  "payment-method-components": "/payment-method-components/static-1.6885",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13788",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3447",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3496",
  "access-control-lib": "/access-control-lib/static-1.10408",
  "EmailComponents": "/EmailComponents/static-1.54689",
  "EmailData": "/EmailData/static-1.53366",
  "redux-less": "/redux-less/static-2.9454",
  "sequences-lib": "/sequences-lib/static-1.7986",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10319",
  "products-ui-components": "/products-ui-components/static-1.39958",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7014",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54637",
  "commerce-products-api": "/commerce-products-api/static-1.2240",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56695",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102576",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80619",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28178",
  "ContentData": "/ContentData/static-1.68343",
  "layout-data-lib": "/layout-data-lib/static-1.9684",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.794",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3907",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3962",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.531",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18541",
  "pricing-pages-api": "/pricing-pages-api/static-1.13653",
  "ContentComponents": "/ContentComponents/static-2.71224",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9891",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1900",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46176",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1038",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18784",
  "automation-ui-types": "/automation-ui-types/static-1.19702",
  "messaging-types-lib": "/messaging-types-lib/static-1.45914",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4475",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7843",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.496",
  "price-books-api": "/price-books-api/static-1.546",
  "price-books-components": "/price-books-components/static-1.604",
  "property-description-translator": "/property-description-translator/static-1.3818",
  "ramp-editor": "/ramp-editor/static-1.69",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3599",
  "totals-ui-components": "/totals-ui-components/static-1.23507",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9196",
  "advanced-menus-core": "/advanced-menus-core/static-1.15083",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12029",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33960",
  "segments-query-core": "/segments-query-core/static-1.1390",
  "demographics-service-types": "/demographics-service-types/static-1.1624",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3156",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5618",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7311",
  "data-token-views": "/data-token-views/static-1.16333",
  "forms-utils-lib": "/forms-utils-lib/static-1.12519",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12964",
  "simple-menus-core": "/simple-menus-core/static-1.15082",
  "simple-menus-lib": "/simple-menus-lib/static-1.16599",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4227",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6774",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7491",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3475",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2576",
  "ContentEditorUI": "/ContentEditorUI/static-2.77026",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3949",
  "web-interactives-components": "/web-interactives-components/static-1.13706",
  "web-interactives-data": "/web-interactives-data/static-1.13707",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.488",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.658",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.948",
  "line-items-api": "/line-items-api/static-1.641",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3794",
  "FireAlarmUi": "/FireAlarmUi/static-1.4488",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4144",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21638",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21101",
  "data-studio-ubb": "/data-studio-ubb/static-1.2633",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26949",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57705",
  "content-management-data-lib": "/content-management-data-lib/static-1.5346",
  "copilot-plugins": "/copilot-plugins/static-1.11027",
  "cta-picker": "/cta-picker/static-1.36316",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3000",
  "editor-components": "/editor-components/static-1.13188",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8359",
  "error-messaging-js": "/error-messaging-js/static-1.5163",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85753",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10617",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1718",
  "smart-content-core": "/smart-content-core/static-1.42350",
  "smart-content-lib": "/smart-content-lib/static-1.43003",
  "social-composer-lib": "/social-composer-lib/static-1.58971",
  "structured-content-lib": "/structured-content-lib/static-1.25106",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53164",
  "tinymce-copilot": "/tinymce-copilot/static-1.16343",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7857",
  "automation-ui-routing": "/automation-ui-routing/static-1.21059",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5611",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42125",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3146",
  "reporting-enablement": "/reporting-enablement/static-1.22807",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21133",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2502",
  "forms-ai-lib": "/forms-ai-lib/static-1.4271",
  "codemirror-dlb": "/codemirror-dlb/static-1.58585",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6401",
  "report-customization-components": "/report-customization-components/static-1.13073",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12900",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.259",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1646"
}
};
